import React from "react";

export const EmptyView = () => {
	return <div style={{ textAlign: 'center', padding: 20 }}>Здесь пока пусто</div>
}


// WEBPACK FOOTER //
// src/components/empty-view.js